// header format// [['NAME'], ['PHONE NUMBER'], ['STATUS']]
// downloadData format for 2 rows// ['SUNIL', 252, 31.7]
// ['test', 9, 1.38]
import { CSVLink } from "react-csv";

export default function GCSVDownload({
  fromScreen,
  headers,
  downloadData,
  filename,
  body,
}) {
  return (
    <>
      <div className="gcsv-container">
        <CSVLink
          onClick={() => null}
          filename={
            filename ||
            "reminder-calls-" +
              new Date().toLocaleString("en-US", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
          }
          className="csv-link2"
          data={downloadData}
          headers={headers}
        >
          {body}
        </CSVLink>
      </div>
    </>
  );
}
